/**
 * @name          jQuery Form Plugin
 * @version       0.1
 * @lastmodified  2016-05-13
 * @package       html-css-js
 * @subpackage    jQuery plugin
 * @author        CH, VI
 *
 * based on: http://jqueryboilerplate.com/
 */

;(function ($, window, document, undefined) {
	'use strict';

	var pluginName = 'form',
		defaults = {
			trackingIdsArray: ''
		};

	// The actual plugin constructor
	function Plugin(element, options) {
		var self = this;
		self.$element = $(element);
		self.$form = self.$element.find('form');
		self.options = $.extend({}, defaults, options);
		self.init();
		self.$element.addClass('form--loaded');
	}

	// methods
	var methods = {
		init: function () {

			var self = this;

			// initially reset forms for IE back button behavior (IE input values remain after back button click)
			$(window).one('load.form', function () {
				setTimeout(function () {
					self.initInputs();
				}, 0);
			});

			if (document.readyState === 'complete') {
				$(window).trigger('load.form');
			} else {
				self.initInputs();
			}

			// checks if form is a multi step Form
			if (self.$element.hasClass('form--multiSteps')) {
				self.prepareMultiStepForm();
			}

			// add datepicker workaround for mobile
			if (global.configuration.get('global.touch') && Modernizr.inputtypes.date) {
				self.$form.find('input[type="date"]').each(function (index, element) {
					var $element = $(element);
					$element.closest('.form__group').addClass('form__group--datePickerTouch');
					var $hiddenElement = $element.parent().after('<input type="hidden" name="' + element.name + '">').next();
					element.name = element.name + '_picker';

					//change date from YYYY-MM-DD to DD.MM.YYYY
					$element.on('change', function () {
						const value = this.value;
						const valueArray = value.split('-');
						if (valueArray.length === 3 && valueArray[0].length === 4) {
							$($hiddenElement).val(valueArray[2] + '.' + valueArray[1] + '.' + valueArray[0]);
						} else {
							$($hiddenElement).val(value);
						}
					});
				});
			}


			// check url params for productCategory <Strom|Gas>
			var param = $.deparam(window.location.search.replace(/^\?/, ''));
			param = param.productCategory;
			if (param && param !== '') {
				param = $.removeHtml(param);
				self.$form.append('<input name="productCategory" type="hidden" value="' + param + '" />');
			}

			// check url params for productInterest <Strom|Gas>
			param = $.deparam(window.location.search.replace(/^\?/, ''));
			param = param.productInterest;
			if (param && param !== '') {
				param = $.removeHtml(param);
				if (self.$form.find('input[name="' + param + '"]')) {
					var $label = self.$form.find('input[name="productInterest"]').closest('fieldset').siblings('p');
					var labelText = $label.text().replace('xy', param);
					$label.text(labelText);
				}
			}


			var $dataToggle = self.$element.find('[data-collapse]');
			var $requiredFields = self.$element.find('.form__toggleElement [data-validation-required]');

			$requiredFields.each(function () {
				$(this).removeAttr('data-validation-required');
				$(this).attr('data-validation-required-bak', true);
			});

			$dataToggle.on('change', function () {

				var $toggleEl = self.$element.find('[data-collapsename="' + $(this).attr('name') + '"]');
				var arr = $(this).data('collapse');
				var selectVal = false;
				var $toggle = $(this);

				arr = arr.split(',');

				$.each(arr, function (e, i) {
					if ($toggle.val() === i) {
						selectVal = true;
						return false;
					} else {
						selectVal = false;
					}
				});

				if (($(this).attr('type') === 'checkbox' && $(this).is(':checked')) || ($(this).data('collapse') === $(this).attr('id') && $(this).attr('type') !== 'checkbox') || (selectVal)) {
					$toggleEl.find('[data-validation-required-bak]').each(function () {
						$(this).attr('data-validation-required', 'true');
						$(this).removeAttr('data-validation-required-bak');
					});

					$toggleEl.slideDown();
					self.$form.parsley()._refreshFields();

				} else {
					$toggleEl.slideUp();
					$toggleEl.find('[data-validation-required]').each(function () {
						$(this).removeAttr('data-validation-required');
						$(this).attr('data-validation-required-bak', true);
					});
					self.$form.parsley()._refreshFields();
				}
			});


			self.initParsley();
			self.scrollFix();


			// UDG, add tracking click for submit button
			/*window.Parsley.on('form:validate', function (form) {
			 if (form.isValid() && self.$form.data('tracking')) {
			 // self.options.trackingIdsArray = self.$form.data('tracking').split(',');
			 // self.sendTracking();
			 // alert("valid");
			 }
			 });*/


			var $customerNumber = self.$element.find('input[data-enabled-by-already-customer="true"]');
			if ($customerNumber.length > 0) {
				var $alreadyCustomer = self.$element.find('input[name="alreadyCustomer"]');
				if ($alreadyCustomer.length > 0) {
					$alreadyCustomer.on('click', function () {
						var $self = $(this);
						var $formGroup = $customerNumber.closest('.form__group');
						if ($self.val() === 'true') {
							$customerNumber.removeAttr('disabled');
							$formGroup.removeClass('form__group--disabled').addClass('form__group--required');
							self.$form.parsley()._refreshFields();
						} else {
							$customerNumber.attr('disabled', 'disabled');
							$formGroup.removeClass('form__group--required').addClass('form__group--disabled');
							$customerNumber.val('');
							self.$form.parsley()._refreshFields();
						}
					});
				}
			}


			// Add datepicker events
			var $dateInput = self.$element.find('[data-toggle="datepicker"]');
			$dateInput.on('focus', function () {
				$(this).addClass('form__element--notEmpty');
			});

			$dateInput.on('focusout', function () {
				var $self = $(this);
				// cant find a better solution by now. the focusout is triggered earlier than the pick.datepicker event
				// so the label jumps down for a secound. the timeout prevent this.
				setTimeout(function () {
					if ($self.val().length === 0) {
						$self.removeClass('form__element--notEmpty');
					}
				}, 100);
			});

			// remove success class from captcha inputs
			if (self.$element.find('.form__group--captcha input').length > 0) {
				self.$element.find('.form__group--captcha input').parsley().on('field:success', function () {
					this.$element.closest('.form__group--captcha').removeClass('form__group--success');
				});
			}

			$dateInput.on('change', function () {
				$(this).trigger('input').focusout();
			});

			// form selectbox init
			this.$element
				.find('.selectbox')
				// The following selectboxes are special cases,
				// they are initialized separately!
				.not('.footer__locationselect, .toolbar__select, .targetGroupFilter__dropdown')
				.selectBox({
					onInitialize: function () {
						var currentValue = this.getValue();
						if (currentValue && currentValue !== '') {
							var parsleyElement = this.$input.parsley();
							parsleyElement.validate();

							this.$input.parent().addClass('has-value');
						}

						if (!Modernizr.input.placeholder) {
							$('input, textarea').placeholder();
						}
						this.$wrapper.find('input').attr('data-validation-excluded', true);
					},
					onChange: function () {
						var currentValue = this.getValue();

						if (currentValue && currentValue !== '') {
							this.$input.parent().addClass('has-value');
						} else {
							this.$input.parent().removeClass('has-value');
						}

						var parsleyElement = this.$input.parsley();
						parsleyElement.reset();
						parsleyElement.validate();
					},
					sortField: 'name',
					limit: 20
				});

			self.setNotEmptyClass();

			// toggle form__container open/close
			var containerDividerWrapper = self.$form.find('.form__dividerWrapper');
			var containerDividerLink = self.$form.find('.form__dividerLink').not('.form__dividerLink__link');
			var containerContent = self.$form.find('.form__container');

			containerDividerLink.on('click', function () {
				containerDividerWrapper.addClass('form__divider--isHidden').css('display', 'none');
				containerDividerWrapper.addClass('form__divider--isHidden').css('display', 'none');
				containerContent.slideDown('slow', function () {
					containerContent.removeClass('form__container--isHidden');
					self.$element.trigger('resized.form');
				});
			});

			self.$form.find('.form__close').on('click', function () {
				containerContent.slideUp('slow', function () {
					containerContent.addClass('form__container--isHidden');
					containerDividerWrapper.fadeIn('slow', function () {
						containerDividerWrapper.removeClass('form__divider--isHidden');
					});
				});
			});

			// google recaptcha


			$.each(self.$form, function (index, value) {
				if (!$(this).hasClass('powerConnection__searchForm')) {
					var tracking = $(this).data('tracking');
					// var id = $(this).attr('id');
					$(this).parsley().on('form:submit', function () {

						if (!self.$form.parent().hasClass('powerConnection__searchSuccess')) {
							$('.powerConnection__searchSuccess').remove();
						}
						/*self.$form.find('input').each(function () {
						 if ($(this).val().length > 0) {
						 console.log($(this).val());
						 }
						 });*/

						// UDG, before submitting check if form has tracking-data
						if (tracking !== '' && tracking !== undefined) {
							if (tracking.toString().indexOf(',') > -1) {
								self.options.trackingIdsArray = tracking.split(',');
								self.sendTracking();
							}
						}

						// if this should validate by captcha and captcha is completed successful
						if (this.$element.hasClass('g-recaptcha--validate') && !window.grecaptchaValid) {
							window.grecaptchaForm = this.$element;
							grecaptcha.execute();
							return false;
						}
					});
				}
			});
		},

		sendTracking: function () {

			if (this.options.trackingIdsArray.length === 2 && this.options.trackingIdsArray[0] !== '' && this.options.trackingIdsArray[1] !== '') {

				// remove iframe
				$('#pmClickFrame').remove();

				// IE8 support => https://stackoverflow.com/a/221297
				if (!Date.now) {
					Date.now = function () {
						return new Date().getTime();
					};
				}

				var url = 'https://ad2.adfarm1.adition.com' +
					'/track' +
					'?tid=' + this.options.trackingIdsArray[0] +
					'&sid=' + this.options.trackingIdsArray[1] +
					'&type=html' +
					'&orderid=' +
					'&itemno=' +
					'&descr=' + Date.now() +
					'&quantity=' +
					'&price=0.00' +
					'&total=0.00';
				// tracking iframe
				var iframe = document.createElement('iframe');
				iframe.id = 'pmClickFrame';
				iframe.src = url;
				iframe.width = 1;
				iframe.height = 1;
				iframe.setAttribute('allowtransparency', 'true');
				iframe.setAttribute('scrolling', 'no');
				iframe.setAttribute('border', '0');
				iframe.setAttribute('marginwidth', 0);
				iframe.setAttribute('marginheight', 0);
				iframe.setAttribute('background-color', 'transparent');
				// append elements to dom
				document.getElementsByTagName('body')[0].appendChild(iframe);
			}
		},

		initInputs: function () {
			if (this.$form.length === 0) {
				console.error('A form module must contain exactly one form.', this.$form);
				return;
			}

			this.$form.get(0).reset();
			this.$form.find('input').each(function () {
				if ($(this).val().length > 0) {
					$(this).addClass('form__element--notEmpty');
				}
			});
		},

		initParsley: function () {
			var self = this;

			// init parsley.js
			self.$form.parsley({
				namespace: 'data-validation-',
				successClass: 'form__group--success',
				errorClass: 'form__group--hasError',
				trigger: 'focusout change',
				excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], :disabled',
				classHandler: function (parsleyField) {
					var fieldSet = parsleyField.$element.closest('.form__group');
					if (fieldSet.length > 0) {
						return fieldSet;
					}
					return parsleyField;
				},
				errorsContainer: function (parsleyField) {
					var fieldSet = parsleyField.$element.closest('.form__group');
					if (fieldSet.length > 0) {
						return fieldSet.find('.form__error');
					}
					return parsleyField;
				}
			});
		},
		setNotEmptyClass: function () {
			// form empty check
			var self = this;
			self.$form.find('.form__element').on('input', function (event) {
				var $element = $(event.target);
				if ($element.val().length > 0) {
					$element.addClass('form__element--notEmpty');
					if ($element.parent().hasClass('selectize-input')) {
						$(this).addClass('form__element--notEmpty');
					}
				} else {
					$element.removeClass('form__element--notEmpty');
					if ($element.parent().hasClass('selectize-input')) {
						$(this).removeClass('form__element--notEmpty');
					}
				}
			});
		},
		prepareMultiStepForm: function () {
			var self = this;
			var $sections = self.$element.find('.form__section');

			self.buildBubbleSteps($sections);

			$('.form__navigation .form__button--previous').on('click', function () {
				self.navigateTo(self.curIndex($sections) - 1, $sections);
				window.scroll({
					top: 0,
					behavior: 'smooth'
				});
			});

			// Next button goes forward if current block validates
			self.$element.find('.form__navigation .form__button--next').on('click', function () {
				if (self.$form.parsley().validate({group: 'block-' + self.curIndex($sections)})) {
					self.navigateTo(self.curIndex($sections) + 1, $sections);
					window.scroll({
						top: 0,
						behavior: 'smooth'
					});
				}
			});

			// Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
			$sections.each(function (index, section) {
				$(section).find(':input').attr('data-validation-group', 'block-' + index);
			});

			self.navigateTo(0, $sections); // Start at the beginning
		},

		buildBubbleSteps: function ($sections) {
			var self = this;
			var $bubbleSteps = self.$element.find('.form__steps');
			$sections.each(function (index, section) {
				var liElement = $(document.createElement('li'));
				var h3Element = $(section).find('h3').html();

				$(section).find('h3').parent().hide();
				liElement.addClass('form__stepItem');

				if (index === 0) {
					liElement.addClass('form__stepItem--active');
				} else {
					liElement.addClass('form__stepItem--upcoming');
				}

				liElement.append(h3Element);
				liElement.attr('data-id', index);
				$bubbleSteps.append(liElement);
			});

			self.$element.find('.form__stepItem').on('click', function () {
				var $element = $(this);
				if ($element.hasClass('form__stepItem--past')) {
					var id = $element.attr('data-id');
					self.navigateTo(parseInt(id), $sections);
				}
			});
		},

		navigateTo: function (index, $sections) {
			var self = this;
			var $bubbleSteps = self.$element.find('.form__stepItem');

			$bubbleSteps.each(function (elementIndex, liElement) {
				var $liElement = $(liElement);
				$liElement.removeClass('form__stepItem--upcoming form__stepItem--active form__stepItem--past');
				if (elementIndex < index) {
					$liElement.addClass('form__stepItem--past');
				}
				if (elementIndex === index) {
					$liElement.addClass('form__stepItem--active');
					self.$element.trigger('multiForm', self.$element);

				}

				if (elementIndex > index) {
					$liElement.addClass('form__stepItem--upcoming');
				}
			});

			// Mark the current section with the class 'form__section--current'
			$sections
				.removeClass('form__section--current')
				.eq(index)
				.addClass('form__section--current');

			// Show only the navigation buttons that make sense for the current section:
			self.$element.find('.form__navigation .form__button--previous').toggle(index > 0);
			var atTheEnd = index >= $sections.length - 1;
			self.$element.find('.form__navigation .form__button--next').toggle(!atTheEnd);
			if ($(window).width() < global.configuration.data.global.bpMedium) {
				self.$element.find('.form__navigation .form__button--previous').html('Zurück zu ' + $sections.eq(index - 1).find('h3').html());
			} else {
				self.$element.find('.form__navigation .form__button--previous').html('Zurück');
			}
			self.$element.find('.form__navigation .form__button--send').toggle(atTheEnd);
		},

		scrollFix: function () {
			var self = this;
			window.Parsley.on('form:validate', function (form) {
				if (!form.isValid()) {
					$('body').offset({top: 0});
					for (var n = 0; n < form.fields.length; n++) {
						if (form.fields[n].validationResult !== true) {
							self.scrollTopFunction();
							break;
						}
					}
				}
			});
		},

		scrollTopFunction: function () {

			window.setTimeout(function () {
				$(document).scrollTop($(document).scrollTop() - $('.header').height() + 5);
			}, 0);
		},

		curIndex: function ($sections) {
			// Return the current index by looking at which section has the class 'form__section--current'
			return $sections.index($sections.filter('.form__section--current'));
		}
	};

	// build
	$.extend(Plugin.prototype, methods);

	// A really lightweight plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn[pluginName] = function (options) {
		this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));

				// DEV-note: include failsafe events only if needed
				// trigger ready event on element
				//$.triggerFailsafeEvent($(this), 'plugin_' + pluginName + '.ready');
			}
		});

		// trigger ready event globally
		//if(this.length > 0) {
		//    $.triggerFailsafeEvent($(window), 'plugin_' + pluginName + '.ready_all');
		//}

		return this;
	};

})(jQuery, window, document);
